interface LocationParts {
  thanaName?: string | null;
  districtName?: string | null;
  divisionName?: string | null;
}

export function formatLocation(parts: LocationParts): string | null {
  const filled = [parts.thanaName, parts.districtName, parts.divisionName].filter(
    (part): part is string => Boolean(part),
  );
  return filled.length > 0 ? filled.join(', ') : null;
}
